"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInstallations = getInstallations;
exports.saveInstallationsInfo = exports.getInstallationsInfo = void 0;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
function getInstallations() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/installations?filterBy=eegSubsidyPayments"));
}
var getInstallationsInfo = exports.getInstallationsInfo = function getInstallationsInfo(harnesId, contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/installations/").concat(harnesId, "/").concat(contractAccountId, "/eegSubsidyPaymentInfo"));
};
var saveInstallationsInfo = exports.saveInstallationsInfo = function saveInstallationsInfo(harnesId, contractAccountId, dataObj) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/installations/").concat(harnesId, "/").concat(contractAccountId, "/eegSubsidyPaymentInfo"), dataObj);
};
var _default = exports.default = {
  getInstallations: getInstallations,
  getInstallationsInfo: getInstallationsInfo,
  saveInstallationsInfo: saveInstallationsInfo
};